import { BaseComponent } from '../../../components/BaseComponent';
import { HBox } from '../../../components/Box';

import { EditSquare, Trash, View } from '../../../components/Icon';
import React from 'react';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import styled from 'styled-components';
import dayjs from 'dayjs';
import { removeInvoiceSubject } from '../../Invoices/actions';
import { updateProduct } from '../actions';

const STATE = {
  email: false,
  target_email_address: '',
  target_email_address_set: false,
  financialContact: null,
  emailContact: null,
  emailTo: '',
};

class ProductOverviewItemActionsComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {}

  renderDeleteSubject() {
    return (
      <div
        style={{ cursor: 'pointer', width: '30px' }}
        onClick={evt => {
          evt.stopPropagation();
          return this.props.deleteProductSubject();
        }}
      >
        <Trash />
      </div>
    );
  }

  renderIcons = () => {
    if (this.props.action == 'productSubjectDelete') {
      return this.renderDeleteSubject();
    }
    return (
      <>
        <HBox vCenter style={{ gap: 10 }}>
          <div
            style={{ cursor: 'pointer', width: '30px' }}
            onClick={evt => {
              evt.stopPropagation();
              this.to(`/products/${this.props.product?.id}`);
            }}
          >
            <View />
          </div>
          <div
            style={{ cursor: 'pointer', width: '30px' }}
            onClick={evt => {
              evt.stopPropagation();
              this.to(`/products/${this.props.product?.id}`);
            }}
          >
            <EditSquare />
          </div>
          <div
            style={{ cursor: 'pointer', width: '30px' }}
            onClick={evt => {
              evt.stopPropagation();
              this.props.update({ name: this.props.product?.name, status: '2' }, () => {});
            }}
          >
            <Trash />
          </div>
        </HBox>
      </>
    );
  };

  render() {
    return <>{this.renderIcons()}</>;
  }
}

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    deleteProductSubject() {
      dispatch(removeInvoiceSubject(ownProps?.product, ownProps.invoiceId));
    },
    update(dto, callback) {
      dispatch(updateProduct(ownProps?.product?.id, dto, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const ProductOverviewItemActions = compose(withConnect, withRouter)(ProductOverviewItemActionsComp);
